import { render, staticRenderFns } from "./xinwenDetail.vue?vue&type=template&id=130d62e8&scoped=true&"
import script from "./xinwenDetail.vue?vue&type=script&lang=js&"
export * from "./xinwenDetail.vue?vue&type=script&lang=js&"
import style0 from "./xinwenDetail.vue?vue&type=style&index=0&id=130d62e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d62e8",
  null
  
)

export default component.exports